import React from "react";
import ReactMarkdown from "react-markdown";

function normalizeListMarkers(content: string): string {
    // Convert '*' list items to h4 sub-headers, keep '-' items as bullet points
    return content.replace(/^(\s*)\*\s+(.+)$/gm, (_, _indent, text) => `#### ${text.trim()}`);
}

export default function MarkdownBlock({ mark_down_content }: { mark_down_content: string }) {
    return (
        <ReactMarkdown
            components={{
                h1: ({ node, ...props }) => (
                    <h1 className="text-2xl font-bold text-gray-900 first:mt-0 mt-6 mb-4" {...props} />
                ),
                h2: ({ node, ...props }) => (
                    <h2 className="text-xl font-bold text-gray-900 first:mt-0 mt-5 mb-3" {...props} />
                ),
                h3: ({ node, ...props }) => (
                    <h3 className="text-lg font-bold text-gray-900 mt-4 mb-2" {...props} />
                ),
                h4: ({ node, ...props }) => (
                    <h4 className="text-base font-semibold text-gray-800 mt-2 mb-1 ps-2" {...props} />
                ),
                h5: ({ node, ...props }) => (
                    <h5 className="text-sm font-bold text-gray-900 mt-2 mb-1 ps-2" {...props} />
                ),
                h6: ({ node, ...props }) => (
                    <h6 className="text-xs font-bold text-gray-900 mt-2 mb-1 ps-2" {...props} />
                ),
                p: ({ node, ...props }) => (
                    <p className="mb-4 text-gray-800 ps-2" {...props} />
                ),
                strong: ({ node, ...props }) => (
                    <strong className="font-bold text-gray-900" {...props} />
                ),
                em: ({ node, ...props }) => <em className="italic" {...props} />,
                ul: ({ node, ...props }) => (
                    <ul className="list-disc list-inside mb-4 ml-4 ps-2" {...props} />
                ),
                ol: ({ node, ...props }) => (
                    <ol className="list-decimal list-inside mb-4 ml-4 ps-2" {...props} />
                ),
                li: ({ node, ...props }) => <li className="mb-2" {...props} />,
                blockquote: ({ node, ...props }) => (
                    <blockquote className="border-l-4 border-gray-300 pl-4 italic my-4 ps-2" {...props} />
                ),
                code: ({ node, ...props }) => (
                    <code className="bg-gray-100 px-1 py-0.5 rounded text-sm font-mono" {...props} />
                ),
                pre: ({ node, ...props }) => (
                    <pre className="bg-gray-100 p-4 rounded overflow-x-auto mb-4 ps-2" {...props} />
                ),
            }}
        >
            {normalizeListMarkers(mark_down_content)}
        </ReactMarkdown>
    );
}